import { useEffect } from "react";
import { PostHeader } from "./header";
import { PostBody } from "./body";
import { PostFooter } from "./footer";
import { IPostOverviewProps } from "./types";

import "fluid-player/src/css/fluidplayer.css";

export function PostOverview({
  post,
  creator,
  revisions,
  flagged,
  videos,
  attachments,
  previews,
  archives_enabled,
  comments,
  postTitle,
  paysite,
}: IPostOverviewProps) {
  return (
    <>
      <PostHeader
        post={post}
        creator={creator}
        postTitle={postTitle}
        paysite={paysite}
        revisions={revisions}
        flagged={flagged}
      />

      <PostBody
        post={post}
        videos={videos}
        attachments={attachments}
        previews={previews}
        archives_enabled={archives_enabled}
      />

      <PostFooter
        comments={comments}
        service={post.service}
        profileID={post.user}
        profileName={creator.name}
      />
    </>
  );
}
